import getApiUrl from "../getApiUrl";

export const importApi = {
    rollbackImport: (queueId, rollbackBy) => getApiUrl.post(`/import/rollback`, {
        queueId,
        rollbackBy
    }),
    importSingleFile: (items) => {
        const { formName, file, queueId, createdBy } = items;
        const formData = new FormData();
        formData.append("file", file);

        return getApiUrl.post(`/import/csv`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            params: {
                formName,
                queueId,
                createdBy,
            },
        }).then(res => res.data).catch(err => err.response ? err.response.data : { success: false, message: err.message });
    },
    filesHistoryByForm: (form, unitId) => getApiUrl.get(`/import/history?form=${form}`, { params: { unitId } }).then(res => res.data).catch(err => err.response ? err.response.data : { success: false, message: err.message }),
    filesHistoryById: (id) => getApiUrl.get(`/import/status/${id}`).then(res => res.data).catch(err => err.response ? err.response.data : { success: false, message: err.message }),
    filesHistoryErrosMsgByForm: (form, id) => getApiUrl.get(`/import/errors?formName=${form}&queueId=${id}`).then(res => res.data).catch(err => err.response ? err.response.data : { success: false, message: err.message }),
    filesHistoryErrorRemove: (objects) => {
        const { id, formName, errorIds, action = null, recordsIds = null } = objects;
        return getApiUrl.post(`/import/clear-error?id=${id}`, { formName, errorIds, action, recordsIds }).then(res => res.data).catch(err => err);
    }
}
